import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    fetchAll(farm, date, contractorTye) {

        let options = {};

        if (contractorTye == 'a') {
            options = Object.assign({}, options = {
                method: 'get',
                url: `/umbraco/api/HSContractorListings/get`,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
        } else {
            options = Object.assign({}, options = {
                method: 'get',
                url: `/umbraco/api/HSContractorListingProjects/get?farmId=${farm}&date=${date}`,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
        }

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchAllApprovedProjectContractors(farm, date) {
        const options = {
            method: 'get',
            url: `/umbraco/api/HSContractorListingProjects/get?farmId=${farm}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingle(id, contractorType) {

        let options = {};

        if (contractorType == 'a') {
            options = Object.assign({}, {
                method: 'get',
                url: `/umbraco/api/HSContractorListings/getsingle?id=${id}`,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
        } else {
            options = Object.assign({}, {
                method: 'get',
                url: `/umbraco/api/HSContractorListingProjects/getsingle?id=${id}`,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
        }

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    delete(id, contractorType) {
        let options = {};

        if (contractorType == 'a') {
            options = Object.assign({}, {
                method: 'delete',
                url: `/umbraco/api/HSContractorListings/delete?id=${id}`,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
        } else {
            options = Object.assign({}, {
                method: 'delete',
                url: `/umbraco/api/HSContractorListingProjects/delete?id=${id}`,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
        }

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    add(contractor, contractorType) {

        const options = {
            method: 'post',
            url: `/umbraco/api/${contractorType == 'a' ? 'HSContractorListings' : 'HSContractorListingProjects'}/Add`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: contractor
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    update(contractor, contractorType) {

        const options = {
            method: 'put',
            url: `/umbraco/api/${contractorType == 'a' ? 'HSContractorListings' : 'HSContractorListingProjects'}/Update`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: contractor
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }
}